// src/pages/History/20thCentury/WorldWarI.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/20th_Century_-_World_War_I.png';

function HistoryPageWorldWarI() {
  return (
    <TopicPage
      topicKey="World War I"
      title="History: World War I"
      backgroundImage={bg}
      startRoute="/History-World-War-I-Go"
      scrollLabels={[
        "Causes of the War",
        "Trench Warfare and Technology",
        "Treaty of Versailles",
      ]}
      backRoute="/history-20th-century"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageWorldWarI;
